import React, { createContext, useContext } from "react";
import { usePageVisibility } from "../hooks/usePageVisibility";

const VisibilityContext = createContext({
  isVisible: true,
});

/**
 * Provides page visibility state to the component tree.
 * Wraps the usePageVisibility hook so a single listener serves all consumers.
 */
export function VisibilityProvider({ children }) {
  const { isVisible } = usePageVisibility();

  return (
    <VisibilityContext.Provider value={{ isVisible }}>
      {children}
    </VisibilityContext.Provider>
  );
}

/**
 * Access page visibility state.
 * @returns {{ isVisible: boolean }}
 */
export function useVisibility() {
  return useContext(VisibilityContext);
}
